import { Component, Fragment, h, Prop, State, Watch } from '@stencil/core';
import { Tags, Translations } from '../../../../../redux/types';
import { Filters } from '../../../../../types/types';
import { trans } from '../../../../../utils/trans';
import { SearchParameters } from '../../../utils';

@Component({
  tag: 'rentware-search-filters-tags',
  shadow: false,
})
export class RentwareSearchFiltersTags {
  @Prop() allTags: Tags;
  @Prop() searchParameters: SearchParameters;
  @Prop() onTagsChange: (any) => void;
  @Prop() changedTags: string[] = [];
  @Prop() translations: Translations;
  @Prop() locale: string;
  @Prop() shownFilters: Filters[];
  @Prop() onFilterAccordionClick: (Filters) => void;

  @State() selectedTags: string[] = [];

  selectAllCheckbox;

  componentWillLoad() {
    if (this.searchParameters?.tags) {
      this.selectedTags = [...this.selectedTags, ...this.searchParameters?.tags];
    }
  }

  componentWillUpdate() {
    this.selectAllCheckbox.checked = this.tagsNames.length === this.selectedTags.length;
  }

  @Watch('changedTags')
  resetTags() {
    this.selectedTags = this.changedTags;
  }

  handleCheckboxClick = (tag, value) => {
    if (value) {
      this.selectedTags = [...this.selectedTags, tag];
    } else {
      this.selectedTags = this.selectedTags.filter(item => item !== tag);
    }

    this.onTagsChange(this.selectedTags);
  };

  selectAllCheckboxes = () => {
    if (this.tagsNames.length !== this.selectedTags.length) {
      this.selectedTags = this.tagsNames;
      this.onTagsChange(this.selectedTags);
    } else {
      this.selectedTags = [];
      this.onTagsChange(this.selectedTags);
    }
  };

  handleAccordionClick = () => {
    this.onFilterAccordionClick(Filters.Tags);
  };

  get makeSelectAll() {
    return (
      <Fragment>
        <rentware-checkbox
          checked={this.tagsNames.length === this.selectedTags.length}
          label={this.selectAllText}
          onInput={this.selectAllCheckboxes}
          inputRef={el => (this.selectAllCheckbox = el)}
        />

        <rentware-spacer size="M" />
      </Fragment>
    );
  }

  makeTagsSelect = tag => {
    const checked = this.selectedTags.includes(tag);

    return (
      <Fragment>
        <rentware-checkbox checked={checked} label={tag} onInput={e => this.handleCheckboxClick(tag, e.target.checked)} />

        <rentware-spacer size="M" />
      </Fragment>
    );
  };

  get selectAllText() {
    return trans('search.selectAll', this.locale, this.translations) + ' (' + this.tagsNames.length + ')';
  }

  get tagsNames() {
    return this.allTags.tags;
  }

  get tagsNumberInfo() {
    return this.selectedTags.length + ' ' + trans('search.selected', this.locale, this.translations);
  }

  render() {
    return (
      <rentware-search-filters-accordion
        label={this.allTags.label || 'Tags'} //todo: translate
        additionalInfo={this.tagsNumberInfo}
        opened={this.shownFilters.includes(Filters.Tags)}
        onAccordionClick={this.handleAccordionClick}
      >
        <div class="FiltersTagsContainer">
          {this.makeSelectAll}

          {this.tagsNames.map(this.makeTagsSelect)}
        </div>
      </rentware-search-filters-accordion>
    );
  }
}
